import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { MoralisProvider } from "react-moralis";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./redux/store";
import "styles/main.scss";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <MoralisProvider
        appId={process.env["REACT_APP_Application_ID"] || ""}
        serverUrl={process.env["REACT_APP_Server_URL"] || ""}
      >
        <App />
      </MoralisProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
